import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import each from "lodash/each";
import filter from "lodash/filter";
import get from "lodash/get";
import includes from "lodash/includes";
import isNull from "lodash/isNull";

function ReportDataExportButton({ title, data, selectedRowKeys, disabled }) {
  const filename = `${title} - ${moment().format("YYYY-MM-DD HHmm")}.csv`;

  const columnsData = get(data, "columns", []);
  const hasSelectedRows = !!selectedRowKeys.length;

  const rowsData = useMemo(() => {
    const rows = get(data, "rows", []);

    let rowsToExport;

    if (!selectedRowKeys.length) {
      rowsToExport = rows;
    } else {
      rowsToExport = filter(rows, row => includes(selectedRowKeys, row.key));
    }

    if (!rowsToExport){
      rowsToExport = [];
    }

    return rowsToExport.map(row => {
      const rowCSVData = {};

      each(row, (value, key) => {
        // Convert `null` values into a string which can be shown in the CSV, rather than that column value being empty.
        rowCSVData[key] = isNull(value) ? "[Not set]" : value;
      });

      return rowCSVData;
    });
  }, [data, selectedRowKeys]);

  const canExport = !!rowsData.length;

  if (!canExport) {
    return null;
  }

  return (
    <Button type="primary" disabled={disabled}>
      <CSVLink data={rowsData} headers={columnsData} filename={filename}>
        {hasSelectedRows ? "Export Selected" : "Export"}
      </CSVLink>
    </Button>
  );
}

ReportDataExportButton.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
  }),
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool.isRequired,
};

ReportDataExportButton.defaultProps = {
  data: null,
};

export default ReportDataExportButton;
